import CloseIcon from "@mui/icons-material/Close"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import React, { useState } from "react"

import { FormProvider, useForm } from "react-hook-form"

import { Box, DialogTitle, IconButton, List, ListItem, Tab } from "@mui/material"
import ListItemText from "@mui/material/ListItemText"
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import { useContext, useEffect } from "react"
import { useDispatch } from "react-redux"
import TokenContext from "../../context/TokenContext"
import CustomSearchSelect from "../CustomSearchSelect"
import { TabContext, TabList, TabPanel } from "@mui/lab"
import { EnviarCompetencia, evaluacionPorPGD, itemsEvaluacionPGDFetch } from "../../Redux/evaluaciones"

const valoracionOpciones = [
  { value: 100000000, label: "Por Debajo De Las Expectativas", ponderation: 1 },
  { value: 100000001, label: "Cumple Parcialmente Las Expectativas", ponderation: 2 },
  { value: 100000002, label: "Cumple Las Expectativas", ponderation: 3 },
  { value: 100000003, label: "Por Encima De Las Expectativas", ponderation: 4 },
  { value: 100000004, label: "Sobresaliente", ponderation: 5 },
]

const ModalCompetencias = ({ open, handleClose, item, etapaCompleta, scoreGlobalCalculado, isLider, idPGD }) => {
  const token = useContext(TokenContext)
  const dispatch = useDispatch()
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"))

  const [valuePrimerTab, setValuePrimerTab] = useState('1'); //value del tablist

  const defaultValues = {
    valoracionModal: null,
    valoracionLiderModal: null,
  }


  const { handleSubmit, setValue, reset, ...methods } = useForm({
    shouldUnregister: false,
    defaultValues,
    mode: "onChange",
    shouldFocusError: true,
  })

  useEffect(() => {
    if (item) {
      Object.keys(item).forEach((key) => {
        setValue(key, item[key]);
      });
    }
  }, [item, setValue]);
    
    
  const submitDatos = (datos) => {

    let itemObjeto;

    if(isLider) {
      itemObjeto = { "new_itemdeevaluaciondedesempeoid": datos.id, "new_valoraciondellider":datos.valoracionLiderModal?.value}
    } else {
      itemObjeto = { "new_itemdeevaluaciondedesempeoid": datos.id, "new_valoracin":datos.valoracionModal?.value}
    }

    dispatch(EnviarCompetencia(token, itemObjeto))
    .then(() => {
      dispatch(evaluacionPorPGD(token, idPGD))
      dispatch(itemsEvaluacionPGDFetch(token, idPGD))
    })
    .catch((error) => console.error("Error:", error));

    // handleClose(datos)
    handleClose()
    reset()
    setValuePrimerTab("1")
  }

  const handleChangePrimerTAB = (event, newValue) => {
    setValuePrimerTab(newValue);
  };


  return (
    <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
      <DialogTitle sx={{ justifyContent: "center", my: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            p: 1,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
      <TabContext value={valuePrimerTab}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
          }}>
            <TabList
              aria-label="scrollable force tabs example"
              onChange={handleChangePrimerTAB} variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              textColor="secondary"
              indicatorColor="secondary"
            >
              <Tab label={item?.competencia} value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
            </TabList>
          </Box>
          <TabPanel value="1">

          <List sx={{ width: "100%" }}>


          <ListItem>
            <ListItemText>
              <strong>Descripción: </strong>
              {item?.descripcion}
            </ListItemText>
          </ListItem>


          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
          }}>
            <TabList
              aria-label="scrollable force tabs example"
              onChange={handleChangePrimerTAB} variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              textColor="secondary"
              indicatorColor="inherit"
            >
              <Tab label="Valoración" value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
            </TabList>
          </Box> 


          {item && item.definicionderangos && item.definicionderangos.split('\n').map((item, index) => {
            if (item.includes(":")) {
              const [firstPart, secondPart] = item.split(":");
              return (
                <ListItem key={index}>
                  <ListItemText>
                    <strong style={{ fontSize: '0.8rem' }}>{firstPart.trim()}:</strong> <span style={{ fontSize: '0.8rem' }}>{secondPart.trim()}</span>
                  </ListItemText>
                </ListItem>
              );
            } else {
              return (
                <ListItem key={index}>
                  <ListItemText>{item}</ListItemText>
                </ListItem>
              );
            }
          })}


        </List>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <FormProvider {...methods}>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              {
                isLider ? (
                  <Grid xs={12} item sx={{ pt: 0, pb: 0, mb: 1 }}>
                    <CustomSearchSelect 
                      options={valoracionOpciones}
                      type="text"
                      name="valoracionLiderModal"
                      lab="Valoración del Lider"
                      disabled={!isLider || etapaCompleta }
                    />
                  </Grid>
                  
                )
                : (
                  <Grid xs={12} item sx={{ pt: 0, pb: 0, mb: 1 }}>
                    <CustomSearchSelect
                      options={valoracionOpciones}
                      type="text"
                      name="valoracionModal"
                      lab="Autoevaluación"
                      disabled={isLider || etapaCompleta }
                    />
                  </Grid>
                )
              }
              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={ etapaCompleta }
                onClick={handleSubmit(submitDatos)}
              >
                Guardar
              </Button>
            </Grid>
          </FormProvider>
        </Grid>
        </TabPanel>
        </TabContext>
      </DialogContent>
    </Dialog>
  )
}

export default ModalCompetencias
